"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Naked = exports.Nav = exports.Link = exports.Secondary = exports.Primary = void 0;
var Buttons_1 = require("./Buttons");
exports.Primary = (0, Buttons_1.makePrimary)('button');
exports.Secondary = (0, Buttons_1.makeSecondary)('button');
exports.Link = (0, Buttons_1.makeLink)('button');
exports.Nav = (0, Buttons_1.makeNav)('button');
exports.Naked = (0, Buttons_1.makeNaked)('button');
exports.default = { Primary: exports.Primary, Secondary: exports.Secondary, Link: exports.Link, Nav: exports.Nav, Naked: exports.Naked };
